<form [formGroup]="form" (ngSubmit)="submitForm()">
  <div [ngClass]="form.controls['current_password'].touched ? (form.controls['current_password'].errors ? 'has-error' : 'has-success') : ''" class="mb-4">
    <label for="current_password">{{ "current_password" | translate }}</label>
    <input id="current_password" type="text" placeholder="{{ 'current_password' | translate }}" class="form-input" formControlName="current_password" />
    <small class="text-danger" *ngIf="form.controls['current_password'].touched && form.controls['current_password'].errors">{{ "please_provide_current_password" | translate }}</small>
  </div>
  <div [ngClass]="form.controls['password'].touched ? (form.controls['password'].errors ? 'has-error' : 'has-success') : ''" class="mb-4">
    <label for="password">{{ "password" | translate }}</label>
    <input id="password" type="text" placeholder="{{ 'password' | translate }}" class="form-input" formControlName="password" />
    <div *ngIf="form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)">
      <small class="text-danger" *ngIf="form.controls['password'].errors?.['required']">{{ "enter_valid_password" | translate }}</small>
      <small class="text-danger" *ngIf="form.controls['password'].errors?.['invalidPassword']">{{ "password_must_be_at_least_6_characters" | translate }}</small>
    </div>
  </div>
  <div [ngClass]="form.controls['confirm_password'].touched ? (form.controls['confirm_password'].errors ? 'has-error' : 'has-success') : ''" class="mb-4">
    <label for="confirm_password">{{ "confirm_password" | translate }}</label>
    <input id="confirm_password" type="password" placeholder="{{ 'confirm_password' | translate }}" class="form-input" formControlName="confirm_password" />
    <small class="text-danger" *ngIf="form.errors?.['notSame'] && form.controls['confirm_password'].touched">
      {{ "passwords_not_match" | translate }}
    </small>
  </div>
  <button type="submit" class="btn btn-primary w-full" [disabled]="loading">
    <ng-container *ngIf="loading; else alternateTranslation">
      <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
      {{ "loading" | translate }}
    </ng-container>
    <ng-template #alternateTranslation>
      {{ "save" | translate }}
    </ng-template>
  </button>
</form>
